module.exports = __webpack_public_path__ + "img/icon-hearing-aid-price.730f6cae.svg";